import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useServiceOrder } from './ServiceOrderLoader'
import { findReplyByQuestionId } from '../_helpers/pdfHelpers'

const Context = React.createContext([])
const { Provider } = Context
export const useParentServiceOrderState = () => React.useContext(Context)
export const useParentServiceOrder = () => useParentServiceOrderState()?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID, $permalinkToken: String) {
    serviceOrder(id: $id, permalinkToken: $permalinkToken, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      checklist {
        id
        name
      }
      address {
        search
        complement
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      user {
        id
        name
        fieldValues {
          id
          value
          field {
            id
            name
          }
        }
      }
      placeId
      place {
        id
        name
        resume
        placeLevelsResume
        fieldValues {
          id
          value
          field {
            id
            name
          }
        }
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          reference
          parentReference
          description
          documents {
            id
            src
            type
            description
          }
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ParentServiceOrderLoader = ({ children }) => {
  const permalinkToken = usePermalinkToken()
  const serviceOrder = useServiceOrder()
  const orderNumber = findReplyByQuestionId(serviceOrder.replies, 15506)
  let { data, ...state } = useQuery(QUERY, {
    variables: { id: orderNumber ? serviceOrder.parentId : -1, permalinkToken: permalinkToken },
    client: serviceOrdersClient,
    skip: !serviceOrder.parentId
  })

  return (
    <StatePresenter {...state} noEmptyMessage>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ParentServiceOrderLoader
